export default function PackageReportsController(
  $q,
  $scope,
  $rootScope,
  orgDataService,
  reportsSharedModelService,
  addReportPackageDialog,
  ssDialogService,
  loaderService,
) {
  const vm = this;

  vm.handleShowAddReportPackage = handleShowAddReportPackage;

  _activate();

  /** ***************************************************
   * Event Handlers
   */

  function handleShowAddReportPackage($event) {
    // Display new report package dialog
    ssDialogService.dialogs.reports.addReportPackageDialog = ssDialogService.alert(
      addReportPackageDialog.getOptions($event, {
        customerId: vm.customerId,
        reportPackage: {
          reportPackageId: 0,
        },
        refreshReportPackage: false,
        usesUpdatedReportPackaging: vm.usesUpdatedReportPackaging,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.addReportPackageDialog);
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    return _initPage().then(() => {
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
      vm.eulaAccepted = true;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshReportPackages', () => {
      _refreshPackagedReports();
    });
  }

  function _initPage() {
    return $q.all([_refreshPackagedReports()]);
  }

  function _refreshPackagedReports() {
    return orgDataService.getCurrentCustomer().then(custResponse => {
      vm.customerId = custResponse.data.customerId;
      vm.usesUpdatedReportPackaging = custResponse.data.usesUpdatedReportPackaging;

      if (vm.usesUpdatedReportPackaging) {
        reportsSharedModelService.getNewPackagedReports(true).then(response => {
          vm.reportPackages = response;
        });
      } else {
        reportsSharedModelService.getOldPackagedReports(true).then(response => {
          vm.reportPackages = response;
        });
      }
    });
  }
}

PackageReportsController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'orgDataService',
  'reportsSharedModelService',
  'addReportPackageDialog',
  'ssDialogService',
  'loaderService',
];
